// src/servicos/representanteServico.js
import axios from 'axios';

// Define a URL base da API dinamicamente
const BASE_API =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://127.0.0.1:8000/api' // URL para ambiente local
    : 'https://mercadinhointeligente.com.br/api'; // URL para ambiente de produção

const BASE_URL =
  window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://127.0.0.1:8000' // URL para ambiente local
    : 'https://mercadinhointeligente.com.br'; // URL para ambiente de produção

sessionStorage.setItem('BASE_URL', JSON.stringify(BASE_URL)); // Armazenando todos os dados

console.log('Base API:', BASE_API); // Apenas para conferir qual URL está sendo usada

// Configura uma instância do Axios com opções padrão
const api = axios.create({
    baseURL: BASE_API,
    timeout: 10000, // 10 segundos de timeout
    headers: {
        'Content-Type': 'application/json',
    },
});
  


// Função para efetuar o login
export const efetuarLogin = async (dados) => {
    console.log('Entrou no efetuarLogin do loginServico.js...');
    console.log('Dados enviados:', dados);
  
    const endpoint = '/auth/loginMelgs';
    const fullUrl = `${api.defaults.baseURL}${endpoint}`; // Concatena a baseURL com o endpoint
    console.log('URL completa da requisição:', fullUrl);
  
    try {
      const response = await api.post(endpoint, dados);
      return response.data; // Retorna a resposta do backend
    } catch (error) {
      console.error('Erro ao efetuar login:', error.response || error.message);
      throw error; // Lança o erro para ser tratado no componente
    }
  };
